import validate from 'jquery-validation';
export default function validateForm() {
  let contentForm = $('[data-formvalidate]');
  if (contentForm.length) {
    contentForm.each(function (index, el) {
        $(this).on("submit", function(e){

        e.preventDefault();

        var form = $(this);

          grecaptcha.ready(function () {
            grecaptcha.execute('6LdIr9sZAAAAADlV6TRsdi3aWTuw19tI6ZPilj1-', {
              action: 'submit'
            }).then(function (token) {

              var match = document.cookie.match(new RegExp('(^| )' + '__trf.src' + '=([^;]+)'));
              var traffic_source = '';
              if (match){
                traffic_source = match[2];
              }              
              
              var data;
              var contentType = "application/x-www-form-urlencoded";
              var processData = true;
              $('.modalLoader').show();
              if ($(form).attr('enctype') == 'multipart/form-data') {
                data = new FormData($('.form-file').get(0));
                data.append('gRecaptchaResponse' , token );
                data.append('traffic_source' , traffic_source );
                contentType = false;
                processData = false;
              } else {
                data = $(form).serialize()+'&gRecaptchaResponse='+ token +'&traffic_source='+ traffic_source;
              }

              $.ajax({
                data: data,
                type: $(form).attr('method'),
                url: $(form).attr('action'),
                dataType: 'json',
                contentType: contentType,
                processData: processData,
                beforeSend: function () {
                  $(form).find('button').addClass('load');
                  $(form).find('input,button').prop("disabled", true);
                },
                success: function (data) {
                  $('.modalLoader').hide();
                  if (data.status) {
                    if ($(form).hasClass('formBag')) {
                      let contentForm = $('.bag__form');
                      let formSuccess = $('.bag__stage--success');
                      contentForm.hide();
                      formSuccess.fadeIn();
                      if (data.script) {
                        console.log('script gerado');
                        
                        let script = document.createElement('script');
                        script.setAttribute('nonce', window.CSP_NONCE);
                        script.textContent = data.script;
                        document.body.appendChild(script);
                      }

                    } else {
                      Swal.fire({
                        title: (data.title) ? data.title : jsi18n.ajax_success_title,
                        html: data.msgSuccess,
                        imageUrl: site_url + 'site/img/iconSuccess.png',
                        imageWidth: 76,
                        imageHeight: 76
                      });
                    }

                    $(form).find('input, button').prop("disabled", false);
                    $(form)[0].reset();
                    $(form).find('button').removeClass('load');
                  } else {
                    Swal.fire({
                      title: jsi18n.form_invalid_title,
                      html: data.msgWarning,
                      imageUrl: site_url + 'site/img/iconError.png',
                      imageWidth: 76,
                      imageHeight: 76
                    });
                    $(form).find('input,button').prop("disabled", false);
                    $(form).find('button').removeClass('load');
                  }
                },
                error: function (data) {
                  $('.modalLoader').hide();
                  Swal.fire({
                    title: jsi18n.ajax_error_title,
                    text: jsi18n.ajax_error_message,
                    imageUrl: site_url + 'site/img/iconError.png',
                    imageWidth: 76,
                    imageHeight: 76
                  });
                  $(form).find('input,button').prop("disabled", false);
                  $(form).find('button').removeClass('load');
                }
              });

            });
          });

      });
    });
  }

  $(function() {
		$(".newsletter-areas, .newsletter__input, .check_news").on('change', function() {
			if ($(this).closest('form').find('.newsletter-areas').val() && $(this).closest('form').find('.newsletter__input').is(':valid') && $(this).closest('form').find('.check_news').is(':checked') && $(this).closest('form').find('input[name="tipo_pessoa"]:checked').val()) {
				$(this).closest('form').find(".bag__btnNext").attr({
					disabled: false
				});
			} else {
				$(this).closest('form').find(".bag__btnNext").attr({
					disabled: true
				});
			}
		});
	});
  
  $(function() {
		$(".newsletter-areas, .blogNewsletter__input, .check_news").on('change', function() {
			if ($(this).closest('form').find('.newsletter-areas').val() && $(this).closest('form').find('.blogNewsletter__input').is(':valid') && $(this).closest('form').find('.check_news').is(':checked')) {
				$(this).closest('form').find(".bag__btnNext").attr({
					disabled: false
				});
			} else {
				$(this).closest('form').find(".bag__btnNext").attr({
					disabled: true
				});
			}
		});
	});
}